export const showNotifications = (state) => state.notifications
export const showCountNotifications = (state) => state.notifications.length
